export let life = {}
export let event = {
  async clickCurrent () {
    await this.methods('confirm', '您将要导出当前页的数据，是否继续?')
    this.methods('exportExcel', 'current')
  },
  async clickAll () {
    await this.methods('confirm', '您将要导出当前搜索条件的所有数据，是否继续?')
    this.methods('exportExcel', 'all')
  },
  async clickExport () {
    let type = await this.methods('confirm')
    if (!type) return
    this.methods('exportExcel', type)
  }
}
export let watch = {}
